import DefaultMapper from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class VerificationLevelMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'user/users';
	}

	prepareUpdate({ type, resource, params, options, mappedResource }) {
		super.prepareUpdate(...arguments);
		options.url = `${API_BASE_PATH_ADMIN}/user/users/${params.id}/verificationlevel`;
		options.body = JSON.stringify({
			verificationLevel: params.data.verificationLevel
		});
	}
}

export default VerificationLevelMapper;
